import { useMemo } from 'react';

import { SectionOrSubSection } from 'approot/activity-builder/activity-builder.constants';
import type { InteractiveLessonSectionOverviewFragment } from '../../lesson-builder.graphql.generated';
import {
  ActivitySettingsControl,
  ActivitySettingsSubSectionControl,
} from './activity-settings-control';
import { findActivity } from './activity.utils';
import { ActivitiesContentType } from 'global/constants';

type Props = {
  section: SectionOrSubSection;
  sectionsOverview: InteractiveLessonSectionOverviewFragment[];
  contentId: number;
  contentType: ActivitiesContentType;
};

const ActivityEdit = ({
  section,
  sectionsOverview,
  contentId,
  contentType,
}: Props) => {
  const activityComponent = useMemo(() => findActivity(section), [section]);

  return (
    <>
      {activityComponent ? (
        <ActivitySettingsControl
          {...activityComponent}
          contentId={contentId}
          contentType={contentType}
        />
      ) : (
        <ActivitySettingsSubSectionControl
          section={section}
          sectionsOverview={sectionsOverview}
        />
      )}
    </>
  );
};

export default ActivityEdit;
